import { render, staticRenderFns } from "./yuanwen-hengji.vue?vue&type=template&id=43c663f1&scoped=true&"
import script from "./yuanwen-hengji.vue?vue&type=script&lang=ts&"
export * from "./yuanwen-hengji.vue?vue&type=script&lang=ts&"
import style0 from "./yuanwen-hengji.vue?vue&type=style&index=0&id=43c663f1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43c663f1",
  null
  
)

export default component.exports